import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { WaitDayOfMonthConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';
import {
  getValidationErrorMessage,
  ValidationError,
} from '@modules/campaigns/Domain/Enums/ValidationErrors';

export class WaitDayOfMonthNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: WaitDayOfMonthConfig) {
    super(id, NodeType.WaitDayOfMonth, position, config);
  }

  isEmptyConfig(): boolean {
    return this.config['partDay'] == null || this.config['dayOfMonth'] == null;
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0) this.childrenNodes.push(node);
    else console.warn('TENEMOS CHILD');
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else console.warn('TENEMOS PARENT');
  }

  initNodeConfig() {
    (this.config as WaitDayOfMonthConfig).partDay = null;
    (this.config as WaitDayOfMonthConfig).dayOfMonth = null;
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];

    if (this.config['partDay'] == null) {
      const errorMessage = getValidationErrorMessage(ValidationError.NO_PART_DAY, {
        nodoType: 'Esperar día del Mes',
      });
      errors.push({ nodeId: this.id, errorMessage });
    }

    if (this.config['dayOfMonth'] == null) {
      const errorMessage = getValidationErrorMessage(ValidationError.NO_DAY_OF_MONTH, {
        nodoType: 'Esperar día del Mes',
      });
      errors.push({ nodeId: this.id, errorMessage });
    }

    return errors;
  }
}
